import { SubscriptionStatusResponse } from '../../interfaces/stripe/stripe-interface';

export interface SubscriptionState {
  subscription: SubscriptionStatusResponse | null;
  loading: boolean;
  error: string | null;
  loaded: boolean; // Flag to indicate if subscription has been loaded at least once
  autoLoadBlocked: boolean; // Flag used to temporarily block auto-loading (e.g. during signup flow)
}

export const initialSubscriptionState: SubscriptionState = {
  subscription: null,
  loading: false,
  error: null,
  loaded: false,
  autoLoadBlocked: false,
};
